// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { Guideline } from './guideline';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class GuidelineAccount extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key FK guideline */
  guidelineId!: string;
  /** Guid key FK account */
  accountId!: string;
  /** FK accountId */
  account!: Account;
  /** FK guidelineId */
  guideline!: Guideline;
}

